// Hosting pricing plans
export const HOSTING_PLANS = [
  {
    slug: "shared",
    name: "Shared",
    tagline: "Launch your first website",
    price: "$4.99",
    period: "/month",
    popular: false,
    features: [
      "10 GB NVMe SSD storage",
      "100 GB monthly bandwidth",
      "1 hosted website",
      "Free SSL certificate",
      "Daily automatic backups",
      "24/7 email support",
      "cPanel control panel",
      "1-click WordPress install",
    ],
  },
  {
    slug: "business",
    name: "Business",
    tagline: "For growing businesses",
    price: "$14.99",
    period: "/month",
    popular: true,
    features: [
      "50 GB NVMe SSD storage",
      "Unlimited bandwidth",
      "Up to 5 websites",
      "Free SSL + Global CDN",
      "Daily backups + 1-click restore",
      "24/7 priority chat support",
      "Free domain (1 year)",
      "10 professional email accounts",
      "WordPress staging",
    ],
  },
  {
    slug: "vps",
    name: "VPS",
    tagline: "Root access, dedicated resources",
    price: "$29.99",
    period: "/month",
    popular: false,
    features: [
      "100 GB NVMe SSD",
      "4 vCPU + 8 GB RAM",
      "5 TB monthly bandwidth",
      "Full root access (SSH)",
      "Linux or Windows OS",
      "Daily snapshots",
      "DDoS protection included",
      "Custom firewall rules",
      "Choice of data center",
    ],
  },
  {
    slug: "managed",
    name: "Managed",
    tagline: "We handle ops, you ship features",
    price: "$79",
    period: "/month",
    popular: false,
    features: [
      "Managed VPS / Dedicated",
      "8 vCPU + 16 GB RAM",
      "Server hardening & patching",
      "Performance optimization",
      "24/7 proactive monitoring",
      "Automated daily backups (30d)",
      "Incident response SLA — 30 min",
      "WordPress / Laravel tuning",
      "Dedicated account manager",
    ],
  },
  {
    slug: "cloud",
    name: "Cloud",
    tagline: "Auto-scaling AWS / GCP infra",
    price: "Custom",
    period: "",
    popular: false,
    features: [
      "Multi-AZ / multi-region deploy",
      "Auto-scaling compute & DB",
      "AWS / GCP / Azure expert team",
      "Infrastructure as Code (Terraform)",
      "CI/CD pipelines included",
      "Kubernetes if required",
      "99.99% uptime SLA",
      "Cost optimization reviews",
    ],
  },
  {
    slug: "dedicated",
    name: "Dedicated",
    tagline: "Bare metal, full control",
    price: "$199",
    period: "/month",
    popular: false,
    features: [
      "Dedicated bare-metal server",
      "Up to 32 cores + 128 GB RAM",
      "Up to 4 × 2 TB NVMe SSDs",
      "10 Gbps network port",
      "Unlimited bandwidth options",
      "Hardware RAID + IPMI access",
      "Free OS installation",
      "Tier-1 data center (SOC2)",
    ],
  },
];

// Comparison features matrix (visual table)
export const HOSTING_COMPARE = [
  { f: "SSD Storage",        plans: { shared: "10 GB",  business: "50 GB",   vps: "100 GB",     managed: "200 GB",  cloud: "Unlimited", dedicated: "8 TB+" } },
  { f: "Bandwidth",          plans: { shared: "100 GB", business: "Unlimited", vps: "5 TB",      managed: "10 TB",   cloud: "Unlimited", dedicated: "Unlimited" } },
  { f: "Free SSL",           plans: { shared: "✓",      business: "✓",       vps: "✓",          managed: "✓",       cloud: "✓",        dedicated: "✓" } },
  { f: "Root SSH",           plans: { shared: "—",      business: "—",       vps: "✓",          managed: "✓",       cloud: "✓",        dedicated: "✓" } },
  { f: "Managed Ops",        plans: { shared: "—",      business: "—",       vps: "—",          managed: "✓",       cloud: "✓",        dedicated: "Add-on" } },
  { f: "DDoS Protection",   plans: { shared: "Basic",  business: "Basic",   vps: "Advanced",   managed: "Advanced", cloud: "Enterprise", dedicated: "Enterprise" } },
  { f: "Support SLA",        plans: { shared: "24h",    business: "4h",      vps: "2h",         managed: "30 min",  cloud: "15 min",   dedicated: "30 min" } },
];
